import { useEffect } from "react";
import { createPortal } from "react-dom";
import { ChevronLeft, ChevronRight, X } from "lucide-react";

export default function Lightbox({ items, index, onClose, onIndex }) {
  const n = items.length;
  const go = (d) => onIndex((index + d + n) % n);

  useEffect(() => {
    const h = (e) => {
      if (e.key === "Escape") onClose();
      if (e.key === "ArrowRight") onIndex((index + 1) % n);
      if (e.key === "ArrowLeft") onIndex((index - 1 + n) % n);
    };
    window.addEventListener("keydown", h);
    return () => {
      window.removeEventListener("keydown", h);
    };
  }, [index, n, onClose, onIndex]);

  if (index === null || index === undefined || !items[index]) return null;
  const it = items[index];
  return createPortal(
    <div className="fixed inset-0 z-[100] bg-[#0b1a14]/95 flex flex-col" data-testid="lightbox-modal">
      <div className="flex items-center justify-between px-4 sm:px-8 h-14 text-[#F9F6F0]">
        <span className="font-mono-num text-xs text-[#D4AF37]">{index + 1} / {n}</span>
        <button onClick={onClose} className="h-10 w-10 flex items-center justify-center rounded-full hover:bg-white/10" data-testid="lightbox-close-btn"><X className="h-5 w-5" /></button>
      </div>
      <div className="relative flex-1 flex items-center justify-center px-2 sm:px-16 min-h-0">
        <img src={it.src} alt={it.caption} className="max-h-full max-w-full object-contain select-none" data-testid="lightbox-image" />
        {n > 1 && (
          <>
            <button onClick={() => go(-1)} className="absolute left-2 sm:left-4 h-11 w-11 rounded-full bg-white/10 hover:bg-white/20 text-white flex items-center justify-center" data-testid="lightbox-prev-btn"><ChevronLeft className="h-6 w-6" /></button>
            <button onClick={() => go(1)} className="absolute right-2 sm:right-4 h-11 w-11 rounded-full bg-white/10 hover:bg-white/20 text-white flex items-center justify-center" data-testid="lightbox-next-btn"><ChevronRight className="h-6 w-6" /></button>
          </>
        )}
      </div>
      <p className="text-center text-sm text-[#F9F6F0]/85 py-4 px-6 font-display text-lg" data-testid="lightbox-caption">{it.caption}</p>
      <div className="flex gap-2 overflow-x-auto px-4 pb-4 justify-center">
        {items.map((t, i) => (
          <button key={t.src} onClick={() => onIndex(i)} className={`h-14 w-20 shrink-0 rounded overflow-hidden border-2 ${i === index ? "border-[#C59B27]" : "border-transparent opacity-60 hover:opacity-100"}`} data-testid={`lightbox-thumb-${i}`}>
            <img src={t.src} alt="" className="h-full w-full object-cover" />
          </button>
        ))}
      </div>
    </div>,
    document.body
  );
}
